import React, { useState } from "react";
import AdminLeftDrawer from "./AdminLeftDrawer";
import MainPane from "./MainPane";
import { Container, Header, LeftPane, RightPane } from "./MainLayout.styles";
import { HEADER_HEIGHT } from "src/constants";

export default ({
  page,
  children,
  showHeading = true,
  totalCount,
  header,
  leftContent,
  hasBorder = true,
  overflowX = "hidden",
  isCollapsed: controlledCollapsed,
  onToggleCollapsed,
  fullBleed = false,
}: {
  page: string;
  children: React.ReactNode;
  showHeading?: boolean;
  totalCount?: number;
  header?: React.ReactNode;
  leftContent?: React.ReactNode;
  hasBorder?: boolean;
  overflowX?: string;
  isCollapsed?: boolean;
  onToggleCollapsed?: () => void;
  fullBleed?: boolean;
}) => {
  const [internalCollapsed, setInternalCollapsed] = useState(true);
  const isCollapsed = controlledCollapsed ?? internalCollapsed;
  const handleToggleCollapsed =
    onToggleCollapsed ?? (() => setInternalCollapsed(!internalCollapsed));
  const showHeader = !!header;
  const headerHeightValue = HEADER_HEIGHT;

  let headerTitleText = "Admin Tools";
  let headerSubTitleText = "Administrative tools and utilities";
  if (page === "pre-approval") {
    headerTitleText = "Pre-Approval Generation";
    headerSubTitleText =
      "Search for a borrower to manage conditions, generate letters, and send pre-approvals — all synced with DigiFi.";
  } else if (page === "conditions-inbox") {
    headerTitleText = "Conditions Inbox";
    headerSubTitleText = "Manage and process condition-related emails";
  }
  if (page === "rcm") {
    headerTitleText = "Contact Manager";
    headerSubTitleText = "";
  }

  return (
    <Container showHeader={!!showHeader}>
      {showHeader && (
        <Header headerHeightValue={headerHeightValue}>{header}</Header>
      )}
      <LeftPane
        showHeader={!!showHeader}
        hasBorder={!!hasBorder}
        headerHeight={headerHeightValue}
        isCollapsed={isCollapsed}
      >
        {leftContent ?? (
          <AdminLeftDrawer
            page={page}
            isCollapsed={isCollapsed}
            onToggleCollapsed={handleToggleCollapsed}
          />
        )}
      </LeftPane>
      <RightPane
        showHeader={!!showHeader}
        headerHeight={headerHeightValue}
        overflowX={overflowX}
        isCollapsed={isCollapsed}
      >
        <MainPane
          showHeading={showHeading}
          page={page}
          headerTitleText={headerTitleText}
          totalCount={totalCount}
          headerSubTitleText={headerSubTitleText}
          fullBleed={fullBleed}
        >
          {children}
        </MainPane>
      </RightPane>
    </Container>
  );
};
